import axios from "axios";

import store from "../../store";
import { decryptPayload, generateRandomId } from "../../shared/helper/common";
import { logoutUser } from "../../store/user/user-action";
import { API_LOGIN } from "./ApiConstant";
import { IS_PRODUCTION, URL_DEV, URL_PRO } from "../constance";

const BASE_URL = IS_PRODUCTION ? `${URL_PRO}/api` : `${URL_DEV}/api`;

export const defaultAxios = axios.create({
  // baseURL: APIBaseUrl,
  // baseURL: "http://51.159.0.19:8001/api",
  baseURL: BASE_URL,
  responseType: IS_PRODUCTION ? "arraybuffer" : "json",
});

const handleLogout = async () => {
  await logoutUser();
};

// Request interceptor for authorization token
defaultAxios.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const token = state?.user?.token ?? "";
    const deviceId = generateRandomId();

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    if (config.url === API_LOGIN) config.headers["X-Device-Id"] = deviceId;
    if (!IS_PRODUCTION) config.headers["X-Mode"] = "gzip";

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

defaultAxios.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      if (response.data && IS_PRODUCTION) {
        const decryptedData = decryptPayload(response.data);
        return decryptedData;
      }
      return response.data;
    } else {
      return Promise.reject({ messages: ["Unknown error occurred"] });
    }
  },
  (error) => {
    const status = error.response?.status;
    let data = error.response?.data;

    if (data && IS_PRODUCTION) {
      data = decryptPayload(data);
    }

    if (status === 401) {
      console.error("Unauthorized, logging out...");

      handleLogout();

      return Promise.reject({
        success: false,
        status: status || 500,
        message: data?.message || "Something went wrong while api failed.",
        data: data?.data || null,
        errors: data?.errors || [],
      });
    }

    console.log("🚀 ~ data:", data);

    return Promise.reject({
      success: false,
      status: status || 500,
      message: data?.message || "Something went wrong while api failed.",
      data: data?.data || null,
      errors: data?.errors || [],
    });
  },
);
